module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Eight hours and several time zones later, Charles Dean found himself at the counter of Polish National Airlines in Heathrow Airport, waiting as one of the ten ugliest women in the world pecked his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nom de passport")]), _vm._v(" into the reservations computer. His handlers had chosen “John Brown” as his cover name, matching it to a cover story claiming he sold metal and plastic fixtures used for filling teeth. Undoubtedly they knew of his fear of dentistry, though if they had really wanted to be perverse they might have given him the first name James and sent him out as a record salesman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, Mr. Brown,” said the reservation clerk. “How long will you stay in Warsaw?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman attempted a smile. Dean realized that his initial assessment was incorrect—she must rank among the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("five")]), _vm._v(" ugliest women in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not long.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Business or pleasure?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Business.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have a brochure of restaurants,” she said, reaching below the counter.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Dean took the pamphlet stoically, unsure whether the woman was moonlighting for the Polish travel board or—and here was a frightening thought—trying to pick him up. When he looked at the pamphlet a few minutes later in the boarding area, he saw that two words separated by several ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("paragraphs in the densely packed jungle of ungrammatical English had been underlined—“King” and “Street.”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His instructions had been to simply use his plane tickets and he would be contacted along the way. This couldn’t be their way of contacting him, could it?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("King Street?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But what else could it be?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean took the brochure and stepped away from the desk. Was King Street a destination or a code word?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He made a circuit around the mall of newsstands, fast-food shops, and currency exchanges, walking slowly to let anyone interested in contacting him do so. When no one stopped him, he went across to the baggage check-in area, checking the suitcase he’d been given. Upstairs, he cleared through security and walked down the hallway to a duty-free area that reminded him of a massive department store. As he headed toward the airline gate, he realized that “King Street” might refer to a display of some sort—booze or perfume, maybe. So he went back through more carefully, perusing the pyramids of Chivas Regal and Baileys, stopping by the Bulova watches, sniffing the Chanel. The only one who came close to him was a three-year-old German girl trying to escape from her mother. He made his way down the tunnel to the gate, where the stiff plastic seats were about a quarter filled. His carry-on baggage contained sales material relating to his dental cover story; he’d managed to read through it twice on the flight over. He was just debating whether to try a third time when a middle-aged doppelganger for Porky Pig—had Porky Pig worn a goatee—pushed down into the seat beside him. Dean noticed that the man had a wire-bound street atlas of Krakow in his open briefcase.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hate Polish National,” said Porky, in what to Dean sounded like a Scottish accent. His light tan loafers were made of thin, expensive-looking leather, but the material of his blue suit pants had begun to pile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah,” replied Dean.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Have you flown it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never before,” said Dean. “First time to Poland.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which was about the only part of his cover story that was actually true.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Porky told Dean that he was a barrister for a reinsurance company, heading to Poland to depose witnesses in a negligence case. He frowned slightly when Dean gave him his fake name and cover. Few people wanted to talk about dental fixtures, though Dean wondered what he would do if he ran into a dentist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Staying in Krakow?” asked Porky.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just a quick business meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then where?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Russia,” said Dean. “It’s wide open for braces. And cosmetic fillings—we have no quality competition. Our crowns are among the best.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll bet.” Porky changed the subject to the weather.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they were talking, a petite Asian woman took a seat across from them. Her pale white hose pulled Dean’s eyes up her legs to a short red miniskirt. Above it she wore a mostly unbuttoned black silk shirt beneath a faded denim jacket. Her milk-white neck and slim face managed to look somehow vulnerable and bored at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their eyes met; the woman’s frown deepened instantly. Dean smiled. The woman got up from the seat, shaking her head as she walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mostly what I do,” said Porky, who had changed the subject once more as Dean indulged in a little gratuitous lust, “is take depositions. Industrial cases. Defective jackhammers, faulty pressure valves, that sort of thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Intriguing,” said Dean.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Porky started detailing his current case, concerning a railroad company that was being sued by passengers, or rather the survivors of passengers, after a coupling failed on a brake system, with horrific results.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The story was about as interesting as dental fillings. Was this guy the agent who was supposed to contact him?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Dean interrupted a finely wrought description of pneu")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("matic couplings to ask if he could look at the street atlas in Porky’s briefcase.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure.” Porky’s sandwich-sized hands jammed against the sides of his briefcase as he unwedged it. The atlas had a few pages creased over, but Dean got the distinct impression the creases had been added to make it look used. He studied the city.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe I can help,” said Porky. “What are you looking for?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean said, “King Street,” and waited for Porky to tear himself out of his fat suit and reveal himself as an American agent. But he did neither, instead scratching his thumb against his temple. “King in English or Polish?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t worry. Somebody’s meeting me at the airport,” said Dean.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced at his watch, then decided he’d hit the gents’ before boarding the Polish plane. Excusing himself, he wandered across the waiting area to the hall with the rest rooms. He entered the men’s room and was just positioning the strap of his carry-on against his shoulder when someone else came in; the sharp click of heels against the floor caught Dean’s attention and he glanced over his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was the Asian woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey,” he started to say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Into the stall,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What the hell?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman leaned toward the sink and waved her hand in front of the faucet. Its motion sensor clicked and water spewed from the tap.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The stall,” she said, pointing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The door opened once again. As Dean glanced toward it the woman took two quick steps to him and wrapped herself around him, her mouth seeking his.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even if her accent hadn’t given her away as an American, Charlie Dean was hardly the sort to forgo a kiss, even if it was offered in a men’s room. Still, he wasn’t entirely comfortable with the situation.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nor was the man who’d come in to use the facilities for their intended purpose. He retreated hastily, the door slamming behind him. In the meantime, the woman had begun pushing Dean backward toward the last toilet stall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh, what’s go—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She slapped him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Idiot,” she hissed, reaching over and waving her hand in front of the flush sensor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What the hell’s the story?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Idiot,” she repeated. She reached into her jacket pocket and pulled out a small, round makeup case. “Here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean took the case. He turned it over and then opened it. There was nothing inside, so he started to give it back. She grabbed it from him, opened it, then pushed it in front of his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What, my five o’clock shadow?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just shut up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something about the mirror wasn’t right. The woman tilted it slightly, clicked something on the back, then frowned and shook her head as she pocketed it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Retina scan?” he asked, finally catching on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did they recruit you off the street?” the woman asked. “Or is it just that you’re from Texas?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do I sound like I’m from Texas?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You sound like you’re from the planet Moron,” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, don’t let that stop you from explaining who the hell you are,” Dean told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Santa Claus. Now why the hell are you talking to a Russian agent?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You idiot. The fat boy sitting next to you in the waiting area works for the Russian Security Service.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He does?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Listen, do me a favor and go home, okay? I don’t have time to baby-sit an NSC wanna-be.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fuck you.”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gee, Chuckie, what a clever comeback. That wow ’em back in Houston?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t come from Texas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know where you’re from.” She glanced toward the door of the rest room, as if she heard someone coming. “Yeah,” she said to herself. “Yeah, yeah, I know. Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean strung his carry-on bag over his shoulder. Except for the fact that she obviously knew who he was, he might have thought the woman psycho.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not that those were mutually exclusive propositions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just go catch your flight,” she told him, turning back around and pointing. “When you get there, in the terminal, go to Gate Two. Gate Two—you can count that high?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ha-ha.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not joking.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t have a ticket beyond Poland. I’m supposed to be going to Surgut, but no one gave me a ticket.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" from Texas. Just buy a ticket on the first flight on the board.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s going to take me to Surgut?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Buy a ticket on the first flight on the board.” She pushed open the door to the stall. “Good-bye.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The door to the men’s room opened before Charlie could grab her. “Ooo-la-la,” said the newcomer, watching her leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, ooo-fucking-la,” said Dean.")])])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page36"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85b76842","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954730_ch04.vue
// module id = 81
// module chunks = 0